module.exports = __webpack_public_path__ + "static/media/a3.0fc36537.pdf";